import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Utils } from '../../../utils/utils';
import { LocalizedRouterService } from '../../../localized-router.service';
import { Router } from '@angular/router';
import { DEFAULT_LANG, LANG_STORAGE_KEY, buildLangUrl, detectBrowserLang, normalizeLang, readLangFromUrl } from '../../../lang.util';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: false
})
export class NavbarComponent implements OnInit, OnDestroy {
  user: any;
  protected Utils = Utils;
  languages: { name: string, code: string }[] = [];
  currentLang = 'en';
  @Input() position: 'fixed' | 'sticky' | 'static' = 'static';

  private langChangeSubscription?: Subscription;

  constructor(
    private translate: TranslateService,
    private localizedRouter: LocalizedRouterService,
    private router: Router) {
    this.languages = [
      { name: this.translate.instant('English'), code: 'gb' },
      { name: this.translate.instant('Italian'), code: 'it' },
      { name: this.translate.instant('Albanian'), code: 'al' },
    ];
    // Fallback iniziale, usato solo finché translate.currentLang non è ancora
    // disponibile (il costruttore gira prima che NavigationEnd/
    // applyLangFromRoute abbiano determinato la lingua effettiva). Precedenza:
    // prefisso di lingua nel path → ?lang esplicito (rotte senza prefisso,
    // es. /my-quotes) → scelta salvata → lingua di sistema.
    const url = this.router.url;
    const search = url.includes('?') ? url.slice(url.indexOf('?')) : '';
    this.currentLang =
      normalizeLang(this.translate.currentLang) ??
      normalizeLang(url.split('/')[1]?.split('?')[0]) ??
      readLangFromUrl(search) ??
      normalizeLang(localStorage.getItem(LANG_STORAGE_KEY)) ??
      detectBrowserLang();
  }

  ngOnInit(): void {
    // La navbar deve riflettere la lingua REALMENTE applicata (che può essere
    // decisa più tardi di questo costruttore, es. dopo il caricamento del lead
    // sul percorso /my-quotes), non ricalcolarla in autonomia.
    this.langChangeSubscription = this.translate.onLangChange.subscribe(event => {
      const lang = normalizeLang(event.lang);
      if (lang) {
        this.currentLang = lang;
      }
    });
  }

  ngOnDestroy(): void {
    this.langChangeSubscription?.unsubscribe();
  }

  onLanguageSelect(code: string) {
    const lang = normalizeLang(code) ?? DEFAULT_LANG;

    this.currentLang = lang;
    localStorage.setItem(LANG_STORAGE_KEY, lang);

    window.location.href = buildLangUrl(window.location.href, lang);
  }


  register() {
    this.localizedRouter.navigate('become-a-partner')
  }

  isCurrentLang(code: string): boolean {
    if (code === 'gb') {
      code = 'en';
    }
    return this.currentLang === code;
  }

}
